import { Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useMe } from '../api/auth'

export function RequestAccessPage() {
  const { t } = useTranslation('auth')
  const { data: me, isLoading } = useMe()

  return (
    <div className="min-h-screen bg-background text-text-primary">
      <header className="border-b border-border bg-surface/60">
        <div className="mx-auto flex max-w-2xl items-center justify-center px-6 py-5">
          <div className="flex items-center gap-2 text-lg font-semibold">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-background">
              V
            </span>
            Voysi AI
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-6 py-10">
        <div className="space-y-6 rounded-xl border border-border bg-surface p-6 shadow-lg">
          <div className="flex items-center gap-4 border-b border-border pb-5">
            <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-surface-elevated text-primary">
              <Mail className="h-6 w-6" />
            </div>
            <div className="min-w-0">
              <h1 className="truncate text-lg font-semibold">
                {t('requestAccess.title')}
              </h1>
              <p className="text-sm text-text-secondary">
                {t('requestAccess.subtitle')}
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-border bg-background px-4 py-3 text-sm">
            <div className="text-xs text-text-secondary">
              {t('requestAccess.signedInAs')}
            </div>
            <div className="mt-0.5 font-mono text-text-primary">
              {isLoading || !me ? '…' : me.user.email}
            </div>
          </div>

          <div className="flex justify-end border-t border-border pt-5">
            <form method="post" action="/logout">
              <button
                type="submit"
                className="rounded-lg border border-border bg-surface-elevated px-4 py-2 text-sm font-medium text-text-primary hover:bg-surface"
              >
                {t('requestAccess.signOut')}
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  )
}
